import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
    state: {
        userList: [],
    },
    mutations: {
    },
    actions: {
        async getSystemRoleAllList(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getSystemRoleAllList`, data)

                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () { }
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {

                    reject(err)
                }
            })
        },
        async getSystemRoleDetail(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getSystemRoleDetail`, data)

                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () { }
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {

                    reject(err)
                }
            })
        },
        async createSystemRole(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/createSystemRole`, data)

                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () { }
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {

                    reject(err)
                }
            })
        },
        async updateSystemRole(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/updateSystemRole`, data)

                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () { }
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {

                    reject(err)
                }
            })
        },
        async deleteSystemRole(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/deleteSystemRole`, data)

                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () { }
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {

                    reject(err)
                }
            })
        },
        async getSystemFuncAllList(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getSystemFuncAllList`, data)

                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () { }
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {

                    reject(err)
                }
            })
        },
    },
    getters: {
    }
}

export default moduleStore;